import styled from "styled-components";

export const SmallTabletList = styled.div`
  --service-list-gap: ${({ theme }) => theme.spacing.spacing_24};
  --service-list-columns: 2;

  flex-wrap: wrap;
  gap: var(--service-list-gap);
  row-gap: var(--service-list-gap);
  display: none;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    display: flex;
  }

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    --service-list-gap: ${({ theme }) => theme.spacing.spacing_32};
    --service-list-columns: 4;
  }

  & > * {
    width: calc(
      (100% / var(--service-list-columns)) - var(--service-list-gap) +
        (var(--service-list-gap) / var(--service-list-columns))
    );
  }
`;

export const OnlyMobile = styled.div`
  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    display: none;
  }
`;
